export default class DomUtil {
    static getMeta(name: string = '') {
        try {
            return document
                .querySelector(`meta[name="${name}"]`)
                .getAttribute('content');
        } catch (e) {
            console.error(e);
            return null;
        }
    }
}

export function findAll<T extends Element>(arr: string[]) {
    return arr.map(a => document.querySelector<T>(a)).filter(a => a !== null);
}